import {
  Autocomplete,
  Button,
  createFilterOptions,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useAutocomplete } from "@refinedev/mui";
import { memo, useEffect, useState } from "react";
import { dataProvider } from "rest-data-provider";
import { useApiUrl } from "@refinedev/core";
import { config } from "config";

interface ICategory {
  "badgeType.name": string;
  badgeTypeId: number;
  badgeUrl: string;
  code: string;
  createdAt: string;
  description: string;
  expirationDate: string;
  expirationDays: number;
  id: string;
  name: string;
  rank: number;
  status: number;
  updatedAt: string;
}
interface ProductRoom {
  isOpen: boolean;
  id: string;
  handleClose: any;
  rows: any;
  fetchBadgeData: any;
}
const filterOptions = createFilterOptions({
  matchFrom: "start",
  stringify: (option: any) => option.name,
});
const AddBadges = memo(function AddProductRoom(props: ProductRoom) {
  const { autocompleteProps } = useAutocomplete({
    resource: "badge",
    pagination: {
      pageSize: config().relationPageSize,
    },
    filters: [
      {
        field: "status",
        operator: "eq",
        value: 0,
      },
    ],
    sorters: [
      {
        field: "name",
        order: "asc",
      },
    ],
  });
  const [open, setOpen] = useState(false);
  const [badges, setBadges] = useState<ICategory[]>([]);
  useEffect(() => {
    setOpen(props.isOpen);
  }, [props.isOpen]);
  const handleClose = (event: any, reason: any) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") return;
    props.handleClose();
  };
  const apiUrl = useApiUrl();
  const saveBadges = async () => {
    for (var i = 0; i < badges.length; i++) {
      await dataProvider(apiUrl).create({
        resource: "product-badge-relation",
        variables: {
          badgeId: badges[i].id,
          productId: props.id,
        },
      });
    }
    props.handleClose();
    props?.fetchBadgeData(props?.id);
  };
  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="responsive-dialog-title">ADD BADGES</DialogTitle>
        <DialogContent>
          <Autocomplete
            {...autocompleteProps}
            multiple
            onInputChange={(event, value) => {}}
            getOptionLabel={(item) => item.name}
            onChange={(event: any, value) => {
              setBadges(value);
            }}
            placeholder="Select a badge"
            filterOptions={filterOptions}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label="Badge"
                  margin="normal"
                  variant="outlined"
                  required
                />
              );
            }}
            style={{ width: "300px" }}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button onClick={saveBadges}>SAVE</Button>
          <Button color="error" onClick={props.handleClose}>
            CANCEL
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default AddBadges;
